// Libraries
import styled from 'styled-components'

// Components
import { Aligner, FormButton } from 'heeds-ds'

export const Form = styled.form``

export const SaveButton = styled(FormButton).attrs(() => ({
  margin: '64px auto',
  size: 'small',
}))``

export const SearchContainer = styled(Aligner).attrs(() => ({
  align: 'flex-start',
  gap: '16px',
}))`
  width: 100%;
`
